import { useLocation, useNavigate } from "react-router-dom";
import styles from "./ViewSelector.module.css";

const ViewSelector = ({ isMobile }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isTareas = location.pathname === "/";
  const isHorario = location.pathname === "/control-horario";

  return (
    <div
      className={`${styles.selectorContainer} ${isMobile ? styles.selectorContainerMobile : ""
        }`}
    >
      <div
        className={`${styles.tab} ${isTareas ? styles.active : ""}`}
        onClick={() => navigate("/")}
      >
        Tareas
      </div>
      <div
        className={`${styles.tab} ${isHorario ? styles.active : ""}`}
        onClick={() => navigate("/control-horario")}
      >
        Horario
      </div>
    </div>
  );
};

export default ViewSelector;
